import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customInfoLabels from "assets/jss/material-dashboard-pro-react/customInfoLabels.jsx";
import {primaryColor} from "../../material-dashboard-pro-react";
import multibanco from "../../../img/multibanco-logo.webp";

const formacoesStyle = {
  ...customCheckboxRadioSwitch,
  ...customInfoLabels,
  tooltip,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  cursosContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    }
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  tableActions: {
    float: "right",
    marginTop: "-50px"
  },
  searchInput: {
    paddingTop: 0,
    marginTop: 0
  },
  addCourseButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  buttonConfirm: {
    width: "150px"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectMenu: {
    zIndex: 9000
  },
  datetime: {
    margin: "15px 0"
  },
  novaFormacaoForm: {
    marginTop: "-20px",
    padding: "0 10px"
  },
  editarFormacaoForm: {
    marginTop: "-20px",
    padding: "0 10px"
  },
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  editObservacoesButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right",
    color: "#f78200",
    "&:hover, &:focus": {
      color: "#ef7c00"
    }
  },
  formacaoButtons: {
    marginTop: 15,
    textAlign: "center",
    "& > *": {
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  confirmarRegistoModal: {
    "& h4": {
      margin: 0,
      marginTop: 5,
      fontSize: 15,
    },
    "& label, a": {
      margin: 0,
      marginTop: 5,
      fontSize: 13,
      color: "inherit",
      fontWeight: 300,
      fontFamily: "Roboto, Helvetica, Arial, sans-serif"
    },
    "& .logo-multibanco": {
      backgroundImage: "url(" + multibanco + ")",
      backgroundSize: "95%",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      height: "50px", width: "120px",
      border: "1px solid #989898",
      borderRadius: "3px",
      marginTop: "4px",
    }
  },
  courseDetails: {
    "& table": {
      width: "100%",
      "& td:first-child": {
        fontWeight: "bold"
      }
    },
    "& .logo-multibanco": {
      backgroundImage: "url(" + multibanco + ")",
      backgroundSize: "95%",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      height: "50px", width: "120px",
      border: "1px solid #989898",
      borderRadius: "3px",
      marginTop: "4px",
    }
  },
  addForm: {
    padding: "0 10px"
  },
  anuncioEditor: {
    minHeight: "85px",
    maxHeight: "300px",
    padding: 5,
    "& .public-DraftStyleDefault-block": {
      margin: "4px 0"
    }
  },
  itemDetalhes: {
    textAlign: "center",
    margin: "18px 0",
    "& h4": {
      margin: 0
    },
    "& p": {
      margin: 0,
      marginTop: 5,
      fontSize: 13,
      textTransform: "uppercase"
    }
  },
  outrosDetalhes: {
    marginTop: 20,
    "& h4": {
      borderBottom: "solid #35ab50 2px",
      display: "inline-block",
      minWidth: "60%"
    }
  },
  eventLabel: {
    textAlign: "center",
    "& h2": {
      margin: 0
    },
    "& p": {
      textTransform: "uppercase",
      margin: 0,
      fontWeight: 500,
      fontSize: 21,
    }
  },
  cardAvaliacao: {
    "& .MuiChip-colorPrimary, & .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track": {
      backgroundColor: primaryColor
    },
    "& .MuiSwitch-colorPrimary.Mui-checked": {
      color: primaryColor
    }
  }
}

export default formacoesStyle;
